export function base64ToUtf8(stringToDecode: string) {
	return new TextDecoder().decode(base64ToBytes(stringToDecode));
}

export function utf8ToBase64(stringToEncode: string) {
	return bytesToBase64(new TextEncoder().encode(stringToEncode));
}

function base64ToBytes(base64: string) {
	const binString = atob(base64);
	return Uint8Array.from(binString, m => m.codePointAt(0) ?? 0);
}

function bytesToBase64(bytes: Uint8Array) {
	const binString = Array.from(bytes, byte => String.fromCodePoint(byte)).join("");
	return btoa(binString);
}
